export default "__VITE_PUBLIC_ASSET__013bfecd__"